var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMensajeria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6711 0H2.44874C1.09632 0 0 1.39909 0 3.125V21.875C0 23.6009 1.09632 25 2.44874 25H23.6711C25.0235 25 26.1199 23.6009 26.1199 21.875V3.125C26.1199 1.39909 25.0235 0 23.6711 0ZM23.6711 3.125V5.78157C22.5273 6.97031 20.7037 8.81875 16.8051 12.7145C15.946 13.577 14.2441 15.6489 13.0599 15.6247C11.876 15.6492 10.1735 13.5766 9.31474 12.7145C5.41681 8.81934 3.59276 6.97051 2.44874 5.78157V3.125H23.6711ZM2.44874 21.875V9.79154C3.6177 10.9798 5.27545 12.6471 7.80219 15.1721C8.91723 16.2923 10.8699 18.765 13.0599 18.7499C15.2392 18.765 17.1671 16.3281 18.3172 15.1727C20.8439 12.6477 22.5021 10.9799 23.6711 9.7916V21.875H2.44874Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMensajeria);
export default __webpack_public_path__ + "static/media/mensajeria.52c80845e22d090837a35ace4ec6022f.svg";
export { ForwardRef as ReactComponent };